import Navigation from '../Navigation';
import TypeIt from "typeit-react";

function Home() {
  return (
    <div>
            <div className='container-fluid mt-2'>
              <Navigation />
              <div className="ibm pb-5 px-md-5 mb-4 rounded-3">
                <div className="container-fluid py-5 px-0">
                  <span className="h1 fw-bold">
                  Researching and implementing <br/>cutting-edge tech for the packaging industry.</span>
                  <br/>
                  <br/>
                  <a href="mailto:team@packplay.co" className='btn btn-lg btn-dark'><strong>Talk to us</strong></a>
                </div>

                <div className='row'>
                  <div className='py-3 col text-muted mb-5'>
                    Our Focuses
                  </div>
                </div>
                <div className='row'>
                  <div className='col-12 col-md-3'>
                    <div style={{width: "100%", borderRadius:3, backgroundImage: 'url(/home/cad.webp)', backgroundSize:'cover', backgroundPosition:'center', height: 250}}>
                    </div>
                    <div className='mt-3'>
                      <h4>Packaging CAD</h4>
                      Precision CAD made for packaging. 3D and 2D design, parametric, and ready for production.
                    </div>
                  </div>
                  <div className='col-12 col-md-3'>
                    <div style={{width: "100%", borderRadius:3,  mixBlendMode:'hard-light',backgroundImage: 'url(/home/pillow.webp)', backgroundSize:'cover', backgroundPosition:'center', height: 250}}>
                    </div>
                    <div className='mt-3'>
                      <h4>Interactive 3D</h4>
                      Gradas<sup>TM</sup> engine that generates portable 3D objects for interactive packaging e-commerce (Web2Package).
                    </div>
                  </div>
                  <div className='col-12 col-md-3'>
                    <div style={{width: "100%",borderRadius:3, mixBlendMode:'hard-light', backgroundImage: 'url(/home/ml.webp)', backgroundSize:'140%', backgroundPosition:'center', height: 250}}>
                    </div>
                    <div className='mt-3'>
                      <h4>Vision AI and LLMs</h4>
                      Low-shot machine learning applied to wide range of printing quality control problems and processes automations.
                    </div>
                  </div>
                  <div className='col-12 col-sm-3'>
                    <div style={{width: "100%", borderRadius:3, mixBlendMode:'hard-light', backgroundImage: 'url(/home/ps1.webp)', backgroundSize:'cover', backgroundPosition:'center', height: 250}}>
                    </div>
                    <div className='mt-3'>
                      <h4>MRP, MPS, Planning</h4>
                      Move fast with flexibility and transparency reducing information frictions and conflicts.
                    </div>
                  </div>
                </div>

                <hr/>
                <div className='row small'>
                  <pre> &copy; PackPlay Technologies. Bangkok, Thailand.</pre>

                </div>
              </div>
            </div>
    </div>
  );
}

export default Home;
